import { render, staticRenderFns } from "./article-tags.vue?vue&type=template&id=a8a24c64&scoped=true&"
import script from "./article-tags.ts?vue&type=script&lang=ts&"
export * from "./article-tags.ts?vue&type=script&lang=ts&"
import style0 from "./article-tags.scss?vue&type=style&index=0&id=a8a24c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a24c64",
  null
  
)

export default component.exports